/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Label from '../Label/Label';
import Datetime from '../Util/Datetime';
import ArrowIcon from './baseline_arrow_right_alt_black_24dp.png';
import './Log.css';

/**
 * Represents the log view.
 */

export default class Log extends Component {

    /**
     * Properties.
     */

    static propTypes = {
        context:                PropTypes.object.isRequired,
        entity:                 PropTypes.object
    }

    /**
     * Default state.
     */

    state = {
        entries:                []
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {
        
        // Preparing

        let e = [];

        if (this.props.entity) {

            // Getting all of the versions

            let versions = [];

            Object.keys(this.props.entity.versions).forEach((version) => {
                versions.push(version.substring(1));
            });

            // Sorting the versions

            versions.sort((a, b) => {
                return parseInt(a, 10) - parseInt(b, 10);
            });

            versions.forEach((v) => {
                let version = this.props.entity.versions['v' + v];
                let attribute = [];

                if (v === '1') {
                    version.attributes.forEach((a) => {
                        attribute.push({ name: a.name, from: null, to: a.value });
                    });
                } else {
                    let prevVersion = this.props.entity.versions['v' + (parseInt(v, 10) - 1)];

                    version.attributes.forEach((a) => {
                        let attrPrevVersion = prevVersion.attributes.find((item) => {
                            return item.id === a.id;
                        });

                        if (attrPrevVersion) {
                            if (attrPrevVersion.value !== a.value) {
                                attribute.push({ name: a.name, from: attrPrevVersion.value, to: a.value });
                            }
                        } else {
                            attribute.push({ name: a.name, from: null, to: a.value });
                        }
                    });
                }

                e.push({ 
                    version:            v, 
                    modificationdate:   version.modificationdate, 
                    modifiedby:         version.modifiedby, 
                    attribute:          attribute 
                });
            });
        }

        this.setState({ entries: e });
    }

    /** 
     * Component renderer.
     */

    render() {

        // Styles

        const styles = {
            entry: {
                marginTop:          8,
            },
            link: {
                color:              '#2196F3',
                fontSize:           12,
                marginLeft:         8
            },
            icon: {
                width:              24,
                height:             24,
                marginTop:          4
            },
            line: {
                width:              '100%'
            }
        };

        let formatLogDate = (d) => {
            let date = new Date(d);
            return `${new Datetime(date).format('yyyy.mm.dd')} ${(date.getHours() < 10 ? '0' : '') + date.getHours()}:${(date.getMinutes() < 10 ? '0' : '') + date.getMinutes()}:${(date.getSeconds() < 10 ? '0' : '') + date.getSeconds()}`; 
        };

        return (
            <div style={styles.log}>
                <hr style={ styles.line }></hr>

                { this.state.entries.sort((a, b) => {
                    return b.version - a.version;
                }).map((item, index) =>
                    item.attribute.length > 0 && <div key={index} className="vertical" style={ styles.entry }>
                        <div className="log-entry vertical">
                            <div className="horizontal">
                                <Label text={this.state.entries.length === (index + 1) ? this.props.context.locale.log.createdby : this.props.context.locale.log.modifiedby} width={160} />
                                <b><Label text={item.modifiedby.name} /></b>
                                <a href={`mailto:${item.modifiedby.email}`} style={styles.link}>{item.modifiedby.email}</a>
                            </div>
                            <div className="horizontal">
                                <Label text={this.state.entries.length === (index + 1) ? this.props.context.locale.log.creationdate : this.props.context.locale.log.modificationdate} width={160} />
                                <b><Label text={formatLogDate(item.modificationdate)} /></b>
                            </div>

                            { item.attribute.map((a, attrindex) => 
                                !(a.from === null && a.to === '') && <div key={attrindex} className="log-entry-value horizontal center">
                                    <div style={{ width: 160 }}><Label text={a.name + ':'} width={160} /></div>
                                    <div><b><Label text={'' + (a.from === null ? '' : a.from) } /></b></div>
                                    <div><img alt="Arrow icon" src={ArrowIcon} style={styles.icon} /></div>
                                    <div><b><Label text={'' + a.to} /></b></div>
                                </div>
                            )}
                        </div>

                        <hr style={ styles.line }></hr>
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Entityview/Log.js